angular.module('Mineler').run(['$templateCache', function($templateCache) {
  $templateCache.put('map/panels/profile/privacy-settings.tpl.html',
    '<div id="map-panel-profile-edit" class="map-secondary-panel"\n' +
    '     ng-controller="PrivacySettingsCtrl" ng-swipe-left="closeEditPanel()" ng-swipe-disable-mouse>\n' +
    '  <div class="row map-panel-heading">\n' +
    '    <div class="small-2 columns">\n' +
    '      <a class="arrow-back" ng-click="closeEditPanel()">\n' +
    '        <i class="fa fa-angle-double-left"></i>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '    <div class="small-13 columns">\n' +
    '      <h3>Privacy Settings</h3>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row profile-edit profile-edit-about">\n' +
    '    <div class="small-15 columns">\n' +
    '      <form name="editPrivacySettingsForm" role="editPrivacySettingsForm">\n' +
    '        <div class="row">\n' +
    '          <div class="small-15 columns">\n' +
    '            <label>Do you want people outside your network to find your profile?</label>\n' +
    '              <input type="radio" name="visibleInSearch" id="visibleInSearchYes" ng-model="privacy.visibleInSearch" ng-value="true" ng-required="true" />\n' +
    '              <label for="visibleInSearchYes">Yes</label>\n' +
    '              <input type="radio" name="visibleInSearch" id="visibleInSearchNo" ng-model="privacy.visibleInSearch" ng-value="false" ng-required="true" />\n' +
    '              <label for="visibleInSearchNo">No</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="small-15 columns">\n' +
    '            <label>\n' +
    '              Who can see your contact details?<br />\n' +
    '              (phone numbers and email)\n' +
    '            </label>\n' +
    '            <select name="contactDetails" ng-model="privacy.contactDetails" ng-required="true">\n' +
    '              <option value="private">Only me</option>\n' +
    '              <option value="network">My network</option>\n' +
    '              <option value="public">Everyone</option>\n' +
    '            </select>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="small-15 columns">\n' +
    '            <label>Who can see your address?</label>\n' +
    '            <select name="addressDetails" ng-model="privacy.addressDetails" ng-required="true">\n' +
    '              <option value="private">Only me</option>\n' +
    '              <option value="network">My network</option>\n' +
    '              <option value="public">Everyone</option>\n' +
    '            </select>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="small-8 small-offset-2 columns">\n' +
    '            <small class="profile-edit-error" ng-show="editProfileErrorMessage">{{editProfileErrorMessage}}</small>\n' +
    '          </div>\n' +
    '          <div class="small-5 columns profile-edit-button-container">\n' +
    '            <span us-spinner="{radius:3, width:3, length: 8, color: \'#ffffff\'}" spinner-key="spinner-profile-edit"></span>\n' +
    '            <button ng-hide="isSaving" class="right button positive" ng-click="save()" ng-disabled=\'editPrivacySettingsForm.$invalid\'>Save</button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);
